module.exports = __webpack_public_path__ + "img/camera.7bddb363.png";